<template lang='pug'>
div(style='width: 100%')
  .columnWidth
    GeneralSettings(
      :canalWebData='canalWebData'
      @test='canalWebData = $event')
    AppearanceSettings(
      :canalWebData='canalWebData',
      :canalWebId='canalWebId')
    ButtonAnimation(:canalWebData='canalWebData')
    AttachmentsSettings(:canalWebData='canalWebData')
    Cors(:canalWebData='canalWebData')
    StopWords(:canalWebData='canalWebData')
  .columnWidth
    ChannelParamsSettings(:canalWebData='canalWebData')
    ButtonAppearance(
      :canalWebData='canalWebData',
      :canalWebId='canalWebId')
    SessionControlSettings(:canalWebData='canalWebData')
    ServiceEvaluationSettings(:canalWebData='canalWebData')
    FCREvaluationSettings(:canalWebData='canalWebData')
    SnippetAudio(:canalWebData='canalWebData', :canalWebId='canalWebId')
</template>
<script>
import GeneralSettings from '@/components/Settings/CanalWeb/General'
import AppearanceSettings from '@/components/Settings/CanalWeb/Appearance'
import AttachmentsSettings from '@/components/Settings/CanalWeb/Attachments'
import ChannelParamsSettings from '@/components/Settings/CanalWeb/ChannelParams'
import SessionControlSettings from '@/components/Settings/CanalWeb/SessionControl'
import ServiceEvaluationSettings from '@/components/Settings/CanalWeb/ServiceEvaluation'
import FCREvaluationSettings from '@/components/Settings/CanalWeb/FCREvaluation'
import ButtonAppearance from '@/components/Settings/CanalWeb/ButtonAppearance'
import ButtonAnimation from '@/components/Settings/CanalWeb/ButtonAnimation'
import Cors from '@/components/Settings/CanalWeb/Cors'
import StopWords from '@/components/Settings/CanalWeb/StopWords'
import SnippetAudio from '@/components/Settings/CanalWeb/SnippetAudio'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'
export default {
  components: {
    ButtonAnimation,
    ButtonAppearance,
    GeneralSettings,
    AppearanceSettings,
    AttachmentsSettings,
    ChannelParamsSettings,
    SessionControlSettings,
    ServiceEvaluationSettings,
    FCREvaluationSettings,
    Cors,
    StopWords,
    SnippetAudio
  },
  props: {
    canalWebData: {
      type: Object,
      default: () => ({})
    },
    canalWebId: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    canalWebData: {
      deep: true,
      handler (nV) {
        this.modified = true
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('webChannel', ['modified'])
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.columnWidth {
  float: left;
  width: 50%;
}
@media (max-width: 1239px) {
  .columnWidth {
    float: left;
    width: 100%;
  }
}
</style>
